function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "IMG_04",
  transform: "translate(-553 -478)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon_Box",
  transform: "translate(553 478)",
  fill: "#fff",
  stroke: "#707070",
  strokeWidth: 1,
  opacity: 0
}, /*#__PURE__*/React.createElement("rect", {
  width: 640,
  height: 376,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 639,
  height: 375,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_16",
  "data-name": "Pfad 16",
  d: "M0,.348v125.3A3.37,3.37,0,0,0,3.392,129h99.217A3.37,3.37,0,0,0,106,125.652V.348A3.37,3.37,0,0,0,102.608-3H3.392A3.37,3.37,0,0,0,0,.348Z",
  transform: "translate(803 611)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_16-2",
  "data-name": "Pfad 16",
  d: "M0,.348v125.3A3.37,3.37,0,0,0,3.392,129h99.217A3.37,3.37,0,0,0,106,125.652V.348A3.37,3.37,0,0,0,102.608-3H3.392A3.37,3.37,0,0,0,0,.348Z",
  transform: "translate(789 623)",
  fill: "#333330",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6
}), /*#__PURE__*/React.createElement("text", {
  id: "_",
  "data-name": "?!",
  transform: "translate(811 721)",
  fill: "#fff",
  fontSize: 100,
  fontFamily: "MatryoshkaS, Matryoshka"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "?!")));

function SvgQuestionmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 640,
    height: 376,
    viewBox: "0 0 640 376",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionmark);
export default __webpack_public_path__ + "static/media/questionmark.7e81e7f2b8806f762948aad9fb02a31b.svg";
export { ForwardRef as ReactComponent };